<template>
  <footer>
    <p>
      <sup>&copy; </sup><span id="year"></span> &nbsp;{{ Name }}. {{ rights }}
    </p>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      rights: "All rights reserved",
      Name: "Mohamed Sabry"
    };
  },
  mounted() {
    document.getElementById("year").innerHTML = new Date().getFullYear();
  }
};
</script>

<style lang="scss">
footer {
  padding: 15px;
  font-size: 1.5rem;

  .fa-heart {
    color: red;
  }
}
</style>
